import { Users, CheckCircle, Clock, DollarSign } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";

export default function StatsGrid({ analytics, pendingUsers, pendingWithdrawals }) {
  const stats = [
    {
      icon: Users,
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      value: analytics?.users?.total || 0,
      label: `${analytics?.users?.active || 0} active users`,
      badge: pendingUsers?.length > 0 ? `${pendingUsers.length} pending` : null,
    },
    {
      icon: CheckCircle,
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
      value: analytics?.tasks?.total || 0,
      label: `${analytics?.tasks?.active || 0} active tasks`,
      badge: null,
    },
    {
      icon: Clock,
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
      value: analytics?.submissions?.total || 0,
      label: "Total submissions",
      badge: analytics?.submissions?.pending > 0 ? `${analytics.submissions.pending} pending` : null,
    },
    {
      icon: DollarSign,
      iconBg: "bg-purple-100",
      iconColor: "text-purple-600",
      value: `$${analytics?.financials?.total_payouts?.toFixed(2) || '0.00'}`,
      label: "Total payouts",
      badge: pendingWithdrawals?.length > 0 ? `${pendingWithdrawals.length} pending` : null,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <Card key={index} className="border-slate-200">
          <CardContent className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-12 h-12 ${stat.iconBg} flex items-center justify-center`}>
                <stat.icon className={`w-6 h-6 ${stat.iconColor}`} />
              </div>
              {stat.badge && (
                <Badge className="bg-amber-100 text-amber-700">{stat.badge}</Badge>
              )}
            </div>
            <p className="text-3xl font-heading font-bold text-slate-900">{stat.value}</p>
            <p className="text-sm text-slate-500">{stat.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
